import React from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { InView } from 'react-intersection-observer';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import {
  SelectSubscriptionBoxes,
  SubscriptionSignupHeader,
  Testimonials,
  HomepageManifesto,
  GetTheBox,
  HowItWorks,
  PastSubs,
  VisibilityPlaceholder,
  Loading,
} from '../../components';
import AsSeenIn from '../../components/asseenin';
import Hero from '../../components/hero';
import BitsyModal from '../../components/bitsy-modal';
import SchemaData from './SchemaData';
import HomeV2 from './HomeV2';
import './style.css';

// Services
import Environment from '../../services/Environment';
import CartUtils from '../../services/CartUtils';
import generalHelpers from '../../services/generalHelpers';
import Auth from '../../services/Auth';
import BitsyApollo from '../../services/BitsyApollo';
import Features from '../../services/Features';
import homepageVariant from '../../services/homepageVariant';
import Yotpo from '../../services/Yotpo';

// Constants
import Content from '../../constants/Content';

class Home extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      provider: Environment.store,
      showMonthlyPlans: true,
      showSocialProof: false,
      showTestimonialsPlus: false,
      showPastSubs: false,
      showHowItWorks: false,
      showSelectSubs: false,
      modalType: 'NONE',
      modalHeader: '',
      // Statsig initializes asynchronously, so the variant can't be read here —
      // componentDidMount resolves it once the client is ready.
      statsigReady: Environment.store !== 'bump',
      showHomepageV2: false,
      heroImageUrl:
        Environment.store === 'bump'
          ? Features.getConfig('homepage-hero').get(
              'imageUrl',
              '/hero.bump.v1.jpg',
            )
          : `/hero.${Environment.store}.v1.jpg`,
      // eslint-disable-next-line camelcase
      experiment2025_showClickablePdp:
        Features.getExperiment('2025_consumer_-_clickablepdp').get(
          'showClickablePdp',
          false,
        ) === true,
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.match.params && this.props.match.params.referralCode) {
      localStorage.setItem(
        'referralCode',
        this.props.match.params.referralCode,
      );
      this.setState({ referralCode: this.props.match.params.referralCode });
    }
    if (this.props.location?.search) {
      const searchParams = new URLSearchParams(this.props.location.search);
      if (searchParams.get('toggle') === 'b') {
        this.setState({ showMonthlyPlans: false });
      }
    }
    const hashString = this.props.location?.hash?.slice(1);
    if (hashString === 'how-it-works' || hashString === 'past-boxes') {
      this.setState({ showHowItWorks: true, showPastSubs: true });
    }
    if (Environment.store === 'bump') {
      await Features.getClient().initializeAsync();
      this.setState({
        // Re-read now the client is up: the constructor only ever sees the default.
        heroImageUrl: Features.getConfig('homepage-hero').get(
          'imageUrl',
          '/hero.bump.v1.jpg',
        ),
        showHomepageV2: homepageVariant.showsHomepageV2({
          logExposure: true,
        }),
        statsigReady: true,
      });
    }
    Yotpo.runScriptWhenIdIsPresent('reviewImageWidget');
  }

  goToCart = () => {
    generalHelpers.goToCart(this.props);
  };

  handleAddPreCheckoutPromo = async (res) => {
    if (res) {
      this.setState(res);
      this.goToCart();
    }
  };

  nextStep = async (plan, subscriptionCouponFromURL) => {
    this.setState({ isLoading: true });
    const res = await CartUtils.addSubscriptionToCart(
      plan,
      this.state.provider,
      null,
      subscriptionCouponFromURL,
    );
    if (res) {
      const isFeatureGateOn =
        Features.featureIsEnabled('2024-enable_new2024checkout') &&
        Environment.store !== 'bitsy';
      const noProductsInCart = !res.productsAndDetails?.length;
      const onlyGWPProductsInCart = res.productsAndDetails?.every(
        (product) => product.isAddedCouponProduct,
      );
      const noInvalidProductsInCart = noProductsInCart || onlyGWPProductsInCart;
      if (isFeatureGateOn && noInvalidProductsInCart) {
        if (!Auth.hasToken()) {
          await BitsyApollo.getEmptyUser();
        }
        const initCartInfo = await CartUtils.getCart();
        const fullUrl = generalHelpers.appendStoredUTMs(
          '/checkout/start-membership',
        );
        const [pathname, search] = fullUrl.split('?');
        this.props.history.push({
          pathname,
          search,
          state: { initCartInfo },
        });
      } else {
        this.setState({ ...res, modalType: 'PRE-CHECKOUT PROMO' });
      }
    }
  };

  showFreeShippingDetails = () => {
    this.setState({ modalType: 'FREE SHIPPING DETAILS' });
  };

  renderModal = () => {
    if (this.state.modalType === 'FREE SHIPPING DETAILS') {
      return (
        <BitsyModal
          isShowingModal
          content='freeShippingDetails'
          onExit={this.exitModal}
          type='bodyAndExitModal'
          h2ClassName='smsOptInTitle'
          modalHeaderClass='smsOptInModalHeader'
          data={{}}
        />
      );
    }
    return null;
  };

  exitModal = () => {
    this.setState({ modalType: 'NONE' });
  };

  viewMonthlyPlans = () => {
    this.setState({ showMonthlyPlans: true });
  };

  viewBundledPlans = () => {
    this.setState({ showMonthlyPlans: false });
  };

  getTheBoxCtaClicked = () => {
    this.props.history.push('/gift');
  };

  goToSixMonthPdp = () => {
    this.props.history.push(
      `/products/${Content.defaultSubscriptionPdpUrlPath[6]}`,
    );
  };

  heroSubscriptionCtaClicked = () => {
    if (
      this.state.experiment2025_showClickablePdp &&
      Environment.store === 'bump'
    ) {
      this.props.history.push(
        `/products/${Content.defaultSubscriptionPdpUrlPath[6]}`,
      );
    } else {
      this.scrollToSubscriptionSelect();
    }
  };

  handleSecondHeroButtonClick = () => {
    this.props.history.push('/gift');
  };

  shopEssentialsClicked = () => {
    this.props.history.push('/shop/all');
  };

  // Cross-domain to the sister store; UTMs ride along for attribution.
  learnMoreBitsyClicked = () => {
    window.location.href = generalHelpers.appendStoredUTMs(
      Content.names.oppositeMainUrl,
    );
  };

  // Mirrors Navigation.goToBreastPump — honors the external-redirect config and
  // preserves stored UTMs either way.
  claimBreastPumpClicked = () => {
    const fullUrl = generalHelpers.appendStoredUTMs('/free-breast-pump/step-1');
    if (
      Features.getConfig('dme_breastpump_redirect')?.value
        ?.useExternalBreastPump === true
    ) {
      window.location.href = fullUrl;
      return;
    }
    const [pathname, search] = fullUrl.split('?');
    this.props.history.push({ pathname, search });
  };

  howItWorksCtaClicked = () => {
    this.scrollToSubscriptionSelect();
  };

  scrollToSubscriptionSelect = () => {
    const subscriptionRow = document.getElementById(
      'homepageSubscriptionSection',
    );

    if (subscriptionRow) {
      subscriptionRow.scrollIntoView();
    }
  };

  onVisibilityChange = (stateKey, isVisible) => {
    if (isVisible && !this.state[stateKey]) {
      this.setState({
        [stateKey]: true,
      });
    }
  };

  onVisibilityTestimonialsPlus = (isVisible) => {
    this.onVisibilityChange('showTestimonialsPlus', isVisible);
  };

  onVisibilityPastSubs = (isVisible) => {
    this.onVisibilityChange('showPastSubs', isVisible);
  };

  onVisibilityHowItWorks = (isVisible) => {
    this.onVisibilityChange('showHowItWorks', isVisible);
  };

  onVisibilitySelectSubs = (isVisible) => {
    this.onVisibilityChange('showSelectSubs', isVisible);
  };

  updateTitle = (title) => {
    if (title) {
      this.setState({ modalHeader: title });
    }
  };

  renderLoading = () => {
    if (this.state.isLoading) {
      return <Loading />;
    }

    return null;
  };

  render() {
    // Held rather than painting legacy and swapping — the flash would be visible
    // and would muddy both arms. Costs one Statsig round trip on every visit.
    if (!this.state.statsigReady) {
      return <Loading />;
    }

    // Redesigned homepage — bump store, treatment arm only. Everyone else keeps
    // the legacy layout below. All cart/checkout logic lives here, passed down.
    if (Environment.store === 'bump' && this.state.showHomepageV2) {
      return (
        <>
          {this.renderLoading()}
          <HomeV2
            heroImageUrl={this.state.heroImageUrl}
            showMonthlyPlans={this.state.showMonthlyPlans}
            referralCode={this.state.referralCode}
            modalHeader={this.state.modalHeader}
            modalType={this.state.modalType}
            planFilter={
              window.location?.search
                ? new URLSearchParams(window.location.search).get('plans')
                : ''
            }
            matchParams={this.props.match?.params}
            nextStep={this.nextStep}
            handleAddPreCheckoutPromo={this.handleAddPreCheckoutPromo}
            goToCart={this.goToCart}
            updateTitle={this.updateTitle}
            viewMonthlyPlans={this.viewMonthlyPlans}
            viewBundledPlans={this.viewBundledPlans}
            heroSubscriptionCtaClicked={this.heroSubscriptionCtaClicked}
            handleSecondHeroButtonClick={this.handleSecondHeroButtonClick}
            shopEssentialsClicked={this.shopEssentialsClicked}
            claimBreastPumpClicked={this.claimBreastPumpClicked}
            learnMoreBitsyClicked={this.learnMoreBitsyClicked}
            getTheBoxCtaClicked={this.getTheBoxCtaClicked}
            howItWorksCtaClicked={this.howItWorksCtaClicked}
            goToSixMonthPdp={this.goToSixMonthPdp}
            showFreeShippingDetails={this.showFreeShippingDetails}
            renderModal={this.renderModal}
          />
          <SchemaData />
        </>
      );
    }

    return (
      <Container className='mainPageContainer'>
        <Helmet>
          {/* Empty Helmet tag will inherit from the main app defaults. */}
        </Helmet>
        {this.renderLoading()}

        {this.state.experiment2025_showClickablePdp &&
          Environment.store === 'bump' && (
            <Hero
              title={Content.home.title}
              subheading={Content.home.description}
              buttonText='SUBSCRIBE'
              handleScrollToElement={this.heroSubscriptionCtaClicked}
              defaultImage={this.state.heroImageUrl}
              layout='left'
              stars
              secondButtonText='Give A Gift'
              handleSecondHeroButtonClick={this.handleSecondHeroButtonClick}
            />
          )}

        {(Environment.store !== 'bump' ||
          !this.state.experiment2025_showClickablePdp) && (
          <Hero
            title={Content.home.title}
            subheading={Content.home.description}
            buttonText='SUBSCRIBE'
            handleScrollToElement={this.heroSubscriptionCtaClicked}
            defaultImage={this.state.heroImageUrl}
            layout='left'
            stars
            secondButtonText='Give A Gift'
            handleSecondHeroButtonClick={this.handleSecondHeroButtonClick}
          />
        )}

        <AsSeenIn />

        <Row
          id='homepageSubscriptionSection'
          className='selectSubscriptionContainer'
        >
          <Col>
            <InView
              rootMargin='25px 0px 0px 0px'
              threshold={0}
              onChange={(inView, entry) =>
                this.onVisibilitySelectSubs(inView, entry)
              }
            >
              {({ ref }) => (
                <div ref={ref}>
                  {this.state.showSelectSubs ? (
                    <>
                      <SubscriptionSignupHeader
                        viewMonthlyPlans={this.viewMonthlyPlans}
                        viewBundledPlans={this.viewBundledPlans}
                        title={Content.subscriptionPlanSelection.title}
                        subtitle={Content.subscriptionPlanSelection.description}
                        showMonthlyPlans={this.state.showMonthlyPlans}
                        fullBackgroundColor={false}
                        subBoxContainerId='sub-wrapper'
                      />
                      <SelectSubscriptionBoxes
                        referralCode={this.state.referralCode}
                        showMonthlyPlans={this.state.showMonthlyPlans}
                        nextStep={this.nextStep}
                        subBoxContainerId='sub-wrapper'
                        handleAddPreCheckoutPromo={
                          this.handleAddPreCheckoutPromo
                        }
                        updateTitle={this.updateTitle}
                        modalTitle={this.state.modalHeader}
                        modalType={this.state.modalType}
                        goToCart={this.goToCart}
                        planFilter={
                          window.location?.search
                            ? new URLSearchParams(window.location.search).get(
                                'plans',
                              )
                            : ''
                        }
                        matchParams={this.props.match?.params}
                      />
                    </>
                  ) : (
                    <VisibilityPlaceholder />
                  )}
                </div>
              )}
            </InView>
          </Col>
        </Row>

        <Row className='freeShippingTextContainer'>
          {this.renderModal()}
          <Col>
            <span id='free-shipping-text'>
              FREE SHIPPING & RETURNS ON ALL SUBSCRIPTIONS
            </span>
            <Button
              className='infoPopupButton'
              variant='incognito'
              onClick={this.showFreeShippingDetails}
              aria-label='More information about free shipping and returns'
              aria-describedby='free-shipping-text'
              type='button'
            >
              <FontAwesomeIcon
                icon={faCircleInfo}
                size='lg'
                aria-hidden='true'
              />
            </Button>
          </Col>
        </Row>

        <InView
          rootMargin='50px 0px 0px 0px'
          threshold={0}
          onChange={(inView, entry) => this.onVisibilityPastSubs(inView, entry)}
        >
          {({ ref }) => (
            <div ref={ref}>
              {this.state.showPastSubs ? (
                <PastSubs />
              ) : (
                <VisibilityPlaceholder />
              )}
            </div>
          )}
        </InView>

        <InView
          rootMargin='50px 0px 0px 0px'
          threshold={0}
          onChange={(inView, entry) =>
            this.onVisibilityHowItWorks(inView, entry)
          }
        >
          {({ ref }) => (
            <div ref={ref}>
              {this.state.showHowItWorks ? (
                <HowItWorks
                  handleHowItWorksCtaClicked={this.howItWorksCtaClicked}
                />
              ) : (
                <VisibilityPlaceholder />
              )}
            </div>
          )}
        </InView>

        <InView
          rootMargin='50px 0px 0px 0px'
          threshold={0}
          onChange={(inView, entry) =>
            this.onVisibilityTestimonialsPlus(inView, entry)
          }
        >
          {({ ref }) => (
            <div ref={ref}>
              {this.state.showTestimonialsPlus ? (
                <>
                  <Testimonials
                    title={Content.testimonials.title}
                    cards={Content.testimonials.cards}
                  />
                  {Environment.store === 'bump' ? (
                    <HomepageManifesto
                      getTheBoxCtaClicked={this.getTheBoxCtaClicked}
                    />
                  ) : null}
                  <GetTheBox getTheBoxCtaClicked={this.getTheBoxCtaClicked} />
                </>
              ) : (
                <VisibilityPlaceholder />
              )}
            </div>
          )}
        </InView>

        <Row>
          <Col>
            <center>
              <h2>The Hype Is Real</h2>
            </center>
          </Col>
        </Row>
        <Row id='reviewImageWidget'>
          <Col>
            <div
              className='yotpo yotpo-pictures-widget'
              data-gallery-id='6967dcba3896d1b93700367c'
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '29px' }}>
          <Col>
            <center>
              <Button
                variant='primary'
                className='cta-button'
                onClick={() => {
                  // e.stopPropagation();
                  this.props.history.push(
                    `/products/${Content.defaultSubscriptionPdpUrlPath[6]}`,
                  );
                }}
                aria-label='Go to six month subscription details page'
              >
                GET STARTED{' '}
              </Button>
            </center>
          </Col>
        </Row>

        <SchemaData />
      </Container>
    );
  }
}

export default withRouter(Home);
